import { render, staticRenderFns } from "./booking.vue?vue&type=template&id=0c074dd6&"
import script from "./booking.vue?vue&type=script&lang=js&"
export * from "./booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports